import { call, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify';
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/SocietyProfileReqs/SocietyProfileReqs'

function* getSocietyProfile(action) {
    try {
        const result = yield call(req.getSocietyProfileReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_SOCIETY_PROFILE_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_SOCIETY_PROFILE_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch profile");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_SOCIETY_PROFILE_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* updateSocietyProfile(action) {
    try {
        const result = yield call(req.updateSocietyProfileReq, action);
        if (result.success === true) {
            toast.success(result.message || "Profile updated successfully");
            yield put({ type: types.UPDATE_SOCIETY_PROFILE_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.UPDATE_SOCIETY_PROFILE_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to update profile");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_SOCIETY_PROFILE_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

export default function* societyProfileSaga() {
    yield takeLatest(types.GET_SOCIETY_PROFILE, getSocietyProfile);
    yield takeLatest(types.UPDATE_SOCIETY_PROFILE, updateSocietyProfile);
}
